/**
 * Main JavaScript entry point
 *
 * This imports all necessary modules and styles
 */

// Import main stylesheet
import "../scss/style.scss";

import initMobileNav from "./modules/mobile-nav";
import initSliders from "./modules/sliders";
import initMarquee from "./modules/marquee";
import initSearchToggle from "./modules/search-toggle";
import initStickyNav from "./modules/sticky-nav";

// DOM ready
document.addEventListener("DOMContentLoaded", function () {
  // Initialize modules

  initMobileNav();

  initSliders();

  initMarquee();

  initSearchToggle();

  initStickyNav();
});
